export const MuiCardContent = () => ({
  styleOverrides: {
    root: {
      ':last-child': {
        paddingBottom: 16
      }
    }
  }
})
